/** Sahifalar uchun: profil sahifasiga o'tish + ruxsat tekshiruvi (menyular va havolalar bir xil qoida bilan). */
import { useMemo } from "react";
import { useNavigate } from "react-router";
import { canOpenPerson, personPath } from "@/components/PersonLink";
import { useMe } from "@/features/auth/hooks";
import type { ProfileAction } from "./profileAction";

export function usePersonNav(): ProfileAction {
  const me = useMe().data;
  const navigate = useNavigate();
  return useMemo(() => ({ open: (id: number) => navigate(personPath(id)), can: (id: number, role?: string | null) => canOpenPerson(me, id, role) }), [me, navigate]);
}
